// User-provided photographs, kept separate from named project references.
export const uploadedPhotos = {
  grayLivingRoom: {
    id: "gray-living-room",
    src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_orico-swiss-design/artifacts/pyfzw2io_174.jpg",
    alt: "Sivi dnevni boravak s televizorom, zidnim profilacijama i drvenim parketom",
    width: 564,
    height: 805,
  },
  tallLivingRoom: {
    id: "tall-window-living-room",
    src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_orico-swiss-design/artifacts/kagd24qm_183.jpg",
    alt: "Dnevni boravak s visokim prozorom, ukrasnim stropom i pogledom na vrt",
    width: 500,
    height: 745,
  },
  woodEntrance: {
    id: "wood-entrance",
    src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_orico-swiss-design/artifacts/fp6hpcj2_1.jpg",
    alt: "Ulaz s drvenim vertikalnim letvicama i tamnim kamenim stupom",
    width: 528,
    height: 728,
  },
  stoneEntrance: {
    id: "stone-entrance",
    src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_orico-swiss-design/artifacts/rg0c95gd_64.jpg",
    alt: "Osvijetljeni kameni ulaz s drvenom oblogom pročelja",
    width: 656,
    height: 670,
  },
  wellness: {
    id: "wellness-sculpture",
    src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_orico-swiss-design/artifacts/niumsszf_38.jpg",
    alt: "Wellness prostor sa zlatnim skulpturalnim elementom i ležaljkama",
    width: 468,
    height: 518,
  },
  bedroom: {
    id: "illuminated-bedroom",
    src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_orico-swiss-design/artifacts/4f5krmcq_767.jpg",
    alt: "Spavaća soba s drvenim krevetom i osvijetljenom zidnom oblogom",
    width: 564,
    height: 705,
  },
  hotelRoom: {
    id: "hotel-room-water-view",
    src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_orico-swiss-design/artifacts/q1q3cyfo_466.jpg",
    alt: "Hotelska soba s drvenim oblogama, balkonom i pogledom na vodu",
    width: 1024,
    height: 666,
  },
  sauna: {
    id: "wood-sauna",
    src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_orico-swiss-design/artifacts/d0h73bl8_859.jpg",
    alt: "Drvena sauna s klupama, peći i osvijetljenim kamenim zidom",
    width: 564,
    height: 376,
  },
  stoneBathroom: {
    id: "stone-bathroom",
    src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_orico-swiss-design/artifacts/ady1nyqa_733.jpg",
    alt: "Kupaonica s kamenim umivaonikom, crnom slavinom i staklenom tuš stijenkom",
    width: 564,
    height: 845,
  },
  poolTerrace: {
    id: "infinity-pool-terrace",
    src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_orico-swiss-design/artifacts/wtxsa956_931.jpg",
    alt: "Preljevni bazen uz drvenu terasu s otvorenim pogledom",
    width: 474,
    height: 628,
  },
  poolLakeside: {
    id: "pool-lakeside-villa",
    src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_orico-swiss-design/artifacts/wc6trp5x_932.jpg",
    alt: "Bazen uz modernu kuću sa staklenom fasadom i pogledom na jezero",
    width: 500,
    height: 662,
  },
  poolCurved: {
    id: "curved-pool-villa",
    src: "https://customer-assets-m6fa6gv7.emergentagent.net/job_orico-swiss-design/artifacts/w2n1uvyw_952.jpg",
    alt: "Zaobljeni preljevni bazen uz vilu i kamenu terasu",
    width: 563,
    height: 377,
  },
};

export const uploadedPhotoBySrc = Object.fromEntries(
  Object.values(uploadedPhotos).map((photo) => [photo.src, photo])
);

export const homeDetailPhotos = [
  uploadedPhotos.woodEntrance,
  uploadedPhotos.wellness,
  uploadedPhotos.stoneEntrance,
  uploadedPhotos.tallLivingRoom,
];